<div class="container !w-full">
  <div class="content">
    <div class="search-results mb-3">
      <div class="p-4" *ngIf="busqueda$ | async as busqueda">
        <mat-card>
          <mat-card-header class="!flex !justify-between">
            <mat-card-title class="!grid !mb-3 card-title"
              >Resultados de la búsqueda</mat-card-title
            >
            <mat-card-subtitle
              class="card-subtitle"
              *ngIf="busqueda.ids.length > 0">
              Se encontraron
              <strong class="!bold" style="color: black">{{
                busqueda.entradas.length
              }}</strong>
              coincidencias.
            </mat-card-subtitle>
            <button
              *ngIf="busqueda.entradas.length > 0"
              class="!uppercase button-blue-color"
              (click)="exportExcel()">
              Exportar a excel
            </button>
          </mat-card-header>
        </mat-card>
        <br />

        <mat-card *ngFor="let entrada of busqueda.entradas" class="mb-3">
          <mat-card-content
            class="!flex !gap-12 !justify-between !justify-items-start !pt-2 !pb-2">
            <div class="!flex-3">
              <p
                class="!m-0 !p-0"
                style="white-space: break-spaces; word-break: break-word">
                Asunto: {{ entrada.asunto }} Tema:
                {{ entrada.tema_descripcion }} Fecha de inicio:
                {{ entrada.fechaInicio | date : "yyyy-MM-dd" }}
              </p>
              <span
                *ngIf="entrada.encontrado && entrada.encontrado.length > 0"
                style="
                  display: inline-block;
                  font-size: 13px;
                  line-height: 14px;
                "
                class="md-subhead">
                Se encontraron coincidencias en:
                <span  style="display: inline-block; word-break: break-word; overflow-wrap: break-word;"  *ngFor="let item of entrada.encontrado">
                  <span
                    style="display: inline-block; font-weight: bold"
                    class="layout-xs-row">
                    <span *ngFor="let index of item.indices; let i = index">
                      {{
                        item.texto.substring(
                          i === 0 ? 0 : index - entrada.tamBusqueda,
                          index
                        )
                      }}
                      <mark>{{
                        item.texto.substr(index, entrada.tamBusqueda)
                      }}</mark>
                      {{
                        item.texto.substring(
                          index + entrada.tamBusqueda,
                          item.indices[i + 1]
                            ? item.indices[i + 1] - entrada.tamBusqueda
                            : undefined
                        )
                      }}
                    </span>
                  </span>
                </span>
              </span>
              <span
                *ngIf="entrada.encontrado && entrada.encontrado.length === 0">
                Se encontraron coincidencias en:</span
              >
            </div>
            <div class="!flex !justify-end !gap-3 !items-start !w-1/3">
              @if(entrada.isHistorico){
              <a
                [routerLink]="['/historico', entrada.idTema, entrada.idEntrada]"
                [queryParams]="{ campo: entrada.campoEncontrado }"
                (click)="setEntrada(entrada)"
                class="!uppercase !whitespace-nowrap button-orange-color">
                Ver historico
              </a>
              } @else {
              <a
                (click)="setEntrada(entrada)"
                target="_blank"
                [routerLink]="['/entrada', entrada.idTema, entrada.idEntrada]"
                [queryParams]="{ campo: entrada.campoEncontrado }"
                class="!uppercase !whitespace-nowrap button-blue-color">
                Ver detalle
              </a>
              }
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
    <a
      [routerLink]="['/entrada/new/add']"
      class="fixed-button"
      mat-fab
      color="warn"
      aria-label="Remove file">
      <mat-icon>add</mat-icon>
    </a>
  </div>
</div>
